<template>
  <div class="root">
    <div class="login"></div>
  </div>
</template>

<script>
// Ortak bilgisayarda bir sonraki kişiye kişisel veri / önceki kullanıcının
// kimliği kalmasın. Tema ve görünüm tercihleri korunur.
const SESSION_KEYS = [
  "authToken",
  "userName",
  "userId",
  "telegram_id",
  "dahili",
  "getOptionList",
  "leads_filters",
];
function clearSession() {
  try {
    SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
    sessionStorage.clear();
  } catch (e) {
    /* depolama kapalı */
  }
}
import AuthService from "../services/auth";
export default {
  name: "logout",
  data() {
    return {
      loading: false,
      form: [],
      messages: [],
      login: false
    };
  },
  mounted() {
    clearSession();
    window.location.href = "/login";
  },
  created() {
    clearSession();
    window.location.href = "/login";
  },
  methods: {
    logout() {
      AuthService.logout();
    }
  }
};
</script>
<style>
.root {
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: center;
}

.login {
  width: 350px;
  display: flex;
  flex-direction: column;
  margin-top: 100px;
}

.login-marg {
  margin-bottom: 10px;
}

.login-button {
  margin-top: 10px;
}
</style>
